import React, { FC } from 'react';
import { SdkCodeSnippetsAsync } from '@cld/sdk-code-snippets';
import { usePlatformAnalytics } from '../../../utils/hooks/useAnalytics/useAnalytics';

export interface ImageRendererProps {
  src: string;
  alt: string;
}

export const SnippetRenderer: FC<React.PropsWithChildren<ImageRendererProps>> = ({ src }) => {
  const analytics = usePlatformAnalytics();

  const handleCopy = (snippet?: { language: string }) => {
    if (snippet) {
      analytics('copy', `copy ${snippet.language.toLowerCase()} code`);
    }
  };

  return <SdkCodeSnippetsAsync url={src} onCopy={handleCopy} />;
};
